import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

const classNames = {
  root: `Grid`,
  cell: `GridCell`,
  noprojects: `GridNoProjects`
};

export function useGridStyles() {
  const { fonts, semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          height: `100%`,
          position: `relative`,
          textAlign: `center`
        }
      ],
      noprojects: [
        classNames.noprojects,
        {
          backgroundColor: semanticColors.bodyBackground,
          color: semanticColors.disabledBodyText,
          margin: `10em`,
          ...fonts.large
        }
      ],
      cell: [
        classNames.cell,
        {
          alignItems: `center`,
          display: `inline-flex !important`,
          "> div": {
            overflow: `hidden`,
            textOverflow: `ellipsis`,
            whiteSpace: `nowrap`
          }
        }
      ]
    }),
    [fonts, semanticColors]
  );
}
